/**
 * A function to create a log object for the 'workspaceSelectorFormLoad' event (evid: 11400)
 *
 * Event description: Workspace selector page loaded - after the user accepts the invitation to join as a collaborator
 *
 * @param {workspaceSelectorFormLoadParams} params - The parameters for this event
 * @property {string} origin_info - From which flow\page the user was referred to this page
 * @return {LogObject<workspaceSelectorFormLoadParams>} LogObject<workspaceSelectorFormLoadParams>
 */
export function workspaceSelectorFormLoad(params) {
    return { evid: 11400, src: 5, endpoint: 'login-react-app', params: params };
}
/**
 * A function to create a log object for the 'workspaceSelectorAccountSelected' event (evid: 11401)
 *
 * Event description: After the user accepts the invitation to join as a collaborator, the user chooses with witch account he will join
 *
 * @param {workspaceSelectorAccountSelectedParams} params - The parameters for this event
 * @property {GUID} account_id_selected - the chosen account id
 * @property {string} origin_info - From which flow\page the user was referred to this page
 * @return {LogObject<workspaceSelectorAccountSelectedParams>} LogObject<workspaceSelectorAccountSelectedParams>
 */
export function workspaceSelectorAccountSelected(params) {
    return { evid: 11401, src: 5, endpoint: 'login-react-app', params: params };
}
/**
 * A function to create a log object for the 'workspaceSelectorUserClickedBack' event (evid: 11402)
 *
 * Event description: the user clicked back on the workspace selector back to the collaborator invite
 *
 * @param {workspaceSelectorUserClickedBackParams} params - The parameters for this event
 * @return {LogObject<workspaceSelectorUserClickedBackParams>} LogObject<workspaceSelectorUserClickedBackParams>
 */
export function workspaceSelectorUserClickedBack(params) {
    return { evid: 11402, src: 5, endpoint: 'login-react-app', params: params };
}
//# sourceMappingURL=index.js.map